//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CreateEmailTemplateModal",
  components: {
    MaterialInput,
    GenericModal,
    SimpleButton
  },
  props: {
    templateName: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    createSucceeded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: ""
    };
  },
  computed: {
    createButtonDisabled() {
      return !this.name;
    }
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    handleShow() {
      if (!isEmpty(this.templateName)) this.name = `${this.templateName} - ${this.$t("global.words.copy")}`;
    },
    handleHide() {
      this.name = "";
      this.$emit("hide");
    },
    handleCreate() {
      this.$emit("create", this.name);
    }
  }
});